export const common = {
    en: {
        notFound: 'Page not found',
        notFoundDesc: 'The page may have been removed, or the address is incorrect. Go back or start from the homepage.',
        notFoundRobots: 'noindex, nofollow',
        back: 'Back',
        home: 'Home',
        readBlog: 'Read blog',
        allArticles: 'All articles',
        chooseCountry: 'Choose country',
        error: {
            title: 'Something went wrong',
            description: 'We encountered an unexpected error. Please try again or return to the homepage.',
            retry: 'Try again',
            goHome: 'Go home',
        },
        tables: {
            metaTitle: 'Data Tables',
            metaDescription: 'Useful travel data tables: prices, comparisons, statistics and other important information for travelers.',
            metaKeywords: 'travel data tables, travel comparison tables, travel prices, travel statistics, trip planning data',
            ogDescription: 'Useful travel data tables',
            heroTitle: 'Data Tables',
            heroSubtitle: 'Useful information in a convenient table format',
            emptyTitle: 'No tables yet',
            emptyDescription: 'Useful data tables will appear here soon',
        },
    },
    ru: {
        notFound: 'Страница не найдена',
        notFoundDesc: 'Возможно, страница удалена или адрес указан неверно. Вернитесь назад или начните с главной.',
        notFoundRobots: 'noindex, nofollow',
        back: 'Назад',
        home: 'Главная',
        readBlog: 'Читать блог',
        allArticles: 'Все статьи',
        chooseCountry: 'Выбрать страну',
        error: {
            title: 'Что-то пошло не так',
            description: 'Произошла непредвиденная ошибка. Попробуйте ещё раз или вернитесь на главную.',
            retry: 'Попробовать снова',
            goHome: 'На главную',
        },
        tables: {
            metaTitle: 'Таблицы данных',
            metaDescription: 'Полезные таблицы для путешествий: цены, сравнения, статистика и другая важная информация для туристов.',
            metaKeywords: 'таблицы для путешествий, данные для путешествий, сравнение сервисов, цены для туристов, статистика путешествий',
            ogDescription: 'Полезные таблицы для путешествий',
            heroTitle: 'Таблицы данных',
            heroSubtitle: 'Полезная информация в удобном табличном формате',
            emptyTitle: 'Таблицы пока не добавлены',
            emptyDescription: 'Скоро здесь появятся полезные таблицы с данными',
        },
    },
};
